module.exports = __webpack_public_path__ + "img/icon-clcg@2x.9e07370d.png";